import Navigation from './Navigation';
import Footer from './Footer';

/**
 * Shell for the static legal pages (Terms, Privacy): public header/footer, a
 * readable column, a title and a last-updated line. Content comes in as
 * <Section> children.
 */
export function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white">{title}</h2>
      <div className="mt-2 space-y-3 text-sm leading-relaxed text-gray-600 dark:text-gray-300">
        {children}
      </div>
    </section>
  );
}

function LegalPage({ title, lastUpdated, children }) {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
      <Navigation />

      <main className="flex-grow">
        <div className="container mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
              Last updated: {lastUpdated}
            </p>
          )}
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LegalPage;
